module.exports = __webpack_public_path__ + "static/media/11.0926976c.png";